import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UsersCourse from './UsersCourse';
import UsersEvent from './UsersEvent';

const Users = ({ data }) => {
  if (data?.typology === 'course') return <UsersCourse />;
  if (data?.typology === 'event') return <UsersEvent />;
  return null;
};

Users.propTypes = {
  data: PropTypes.object,
};

export default connect(
  (state) => {
    const { course: data } = state.statistics;
    return {
      data,
    };
  },
  (dispatch) => ({})
)(Users);
